import type { VenueBook } from '@/views/ValueDashboard/types';

/** Render-only projection. Retained levels stay explicitly stale even if an
 * independent ticker has confirmed its price. Never feed this to sizing,
 * queue alerts or submission. Strict fields on the original book are intact. */
export function bookForDisplayOnly(book: VenueBook | null | undefined): VenueBook | null {
  if (!book) return null;
  if (!book.retainedDepth) return book;
  return { ...book, yes: book.retainedDepth.yes, no: book.retainedDepth.no,
    liquidity: book.retainedDepth.liquidity, freshness: 'stale', sourceValidity: 'unconfirmed' };
}
